module.exports = __webpack_public_path__ + "static/media/dinein.42d4d5be.svg";